/* =========================================================================
   CHARMANTE — comportements partagés
   Menu drawer · reveal au scroll · panier · newsletter · toast
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- Menu drawer ---------- */
  const drawer = document.getElementById('drawer');
  const scrim  = document.getElementById('scrim');
  const openBtn = document.getElementById('menuOpen');
  const closeBtn = document.getElementById('menuClose');

  function openMenu() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('a, button')?.focus();
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    openBtn?.focus();
  }
  openBtn?.addEventListener('click', openMenu);
  closeBtn?.addEventListener('click', closeMenu);
  scrim?.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });
  // Piège de focus : maintient la tabulation à l'intérieur du menu ouvert
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('is-open')) return;
    const f = drawer.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Reveal au scroll ---------- */
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
    /* Filet de sécurité : sur certains mobiles l'IntersectionObserver rate des éléments (ex. best-sellers) → ils restent
       en opacity:0 (invisibles). On révèle aussi, en secours, tout [data-reveal] entré dans le viewport (au chargement + au scroll). */
    let pending = Array.prototype.slice.call(reveals);
    const sweep = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      pending = pending.filter((el) => {
        if (el.classList.contains('is-in')) return false;
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.98 && r.bottom > 0) { el.classList.add('is-in'); return false; }
        return true;
      });
      if (!pending.length) { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); }
    };
    let ticking = false;
    const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; sweep(); }); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('load', sweep);
    sweep();
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  // Le panier (état, badge, ajout) est géré par cart.js
  window.Charmante = window.Charmante || {};

  /* ---------- Toast ---------- */
  let toastTimer;
  function showToast(msg) {
    let t = document.getElementById('toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'toast'; t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
    t.querySelector('span').textContent = msg;
    requestAnimationFrame(() => t.classList.add('is-show'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-show'), 3200);
  }
  window.Charmante.showToast = showToast;

  /* ---------- Newsletter ---------- */
  document.querySelectorAll('[data-newsletter]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const help = form.querySelector('.field-help');
      const email = form.querySelector('input[type="email"]');
      if (!email.checkValidity()) {
        if (help) help.textContent = 'Oups, vérifie ton adresse e-mail 💌';
        email.focus();
        return;
      }
      // Inscription newsletter = source de vérité unique → active aussi les -10 %
      const nl = window.Charmante && window.Charmante.newsletter;
      if (nl) nl.subscribe(email.value);
      if (help) help.textContent = nl ? 'Merci ! Tes -10 % sont activés ☀️' : 'Merci ! Surveille ta boîte mail ☀️';
      form.reset();
      showToast(nl ? '🎉 -10 % activés grâce à la newsletter !' : 'Inscription confirmée');
    });
  });

  /* ---------- Bandeau d'annonces rotatif (fondu + glissement vertical) ---------- */
  document.querySelectorAll('[data-topbar]').forEach((rot) => {
    const msgs = Array.from(rot.querySelectorAll('.topbar__msg'));
    if (msgs.length < 2) return;
    let i = 0;
    function rotate() {
      const current = msgs[i];
      i = (i + 1) % msgs.length;
      const next = msgs[i];
      // Le message courant sort vers le haut (fondu), le suivant entre par le bas
      current.classList.remove('is-active');
      current.classList.add('is-exit');
      current.setAttribute('aria-hidden', 'true');
      next.classList.remove('is-exit');
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      // Réinitialise l'ancien message en position basse (invisible) une fois sorti
      setTimeout(() => current.classList.remove('is-exit'), 600);
    }
    setInterval(rotate, 4000);
  });

  /* ---------- Année footer ---------- */
  document.querySelectorAll('[data-year]').forEach((el) => { el.textContent = new Date().getFullYear(); });
})();
